import React from "react";

const statusClasses = {
  scheduled: "badge-scheduled",
  ongoing: "badge-ongoing",
  completed: "badge-completed",
  expired: "badge-expired",
  archived: "badge-completed",
};

const statusLabels = {
  scheduled: "Scheduled",
  ongoing: "Ongoing",
  completed: "Completed",
  expired: "Expired",
  archived: "Archived",
};

export default function Badge({ status, children, className = "" }) {
  const cls = statusClasses[status] || "badge-completed";
  return (
    <span className={`badge ${cls} ${className}`}>
      <span className="badge-dot" aria-hidden="true" />
      {children || statusLabels[status] || status}
    </span>
  );
}
